import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDList,
  FDListItem,
  FDListItemSecondary,
  FDListItemText,
  FDSecondaryActionIconButton,
  FDStack,
} from '@facet-wealth/design';
import { DialogContent } from 'Views/Page/Content/Modal/Components';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import WizardStepDeleteButton from 'Views/Page/Content/Modal/Layouts/DefaultFDWizardStep/Layout/WizardStepDeleteButton';

const ListButton = ({ relationship, handleClick }) => (
  <FDListItem onClick={handleClick(relationship)}>
    <FDListItemText primaryText={relationship.meta('prompt')} />
    <FDListItemSecondary>
      <FDSecondaryActionIconButton icon="edit" />
    </FDListItemSecondary>
  </FDListItem>
);

ListButton.propTypes = {
  relationship: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
};

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { clearModalCollection, loadModalCollectionByLink } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();

  const handleDelete = async () => {
    try {
      await resource.delete();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  const onDeleteSuccess = () => {
    clearModalCollection();
  };

  const handleClick = (rel) => () => {
    loadModalCollectionByLink(rel.link('related').url());
  };

  return (
    <>
      <MetaControlField attr={'title'} />
      <DialogContent>
        <FDStack direction="column" spacing={3}>
          <MetaControlField attr={'memberName'} />
          <FDStack direction="column" alignItems="center" spacing={1}>
            <FDList variant="separated">
              {resource.withRelationship(fr.relationships.basicInformation.name, (rel) => (
                <ListButton relationship={rel} handleClick={handleClick} />
              ), () => null)}
              {resource.withRelationship(fr.relationships.retirementContributions.name, (rel) => (
                <ListButton relationship={rel} handleClick={handleClick} />
              ), () => null)}
              {resource.withRelationship(fr.relationships.deductions.name, (rel) => (
                <ListButton relationship={rel} handleClick={handleClick} />
              ), () => null)}
            </FDList>
            {resource.meta().canDelete() ? (
              <WizardStepDeleteButton
                onDelete={handleDelete}
                onDeleteSuccess={onDeleteSuccess}
                dialogProps={{
                  title: 'Are you sure?',
                  message: 'Removing this job will delete all of its information. This cannot be undone.',
                  confirmLabel: 'Remove',
                }}
              />
            ) : null}
          </FDStack>
        </FDStack>
      </DialogContent>
    </>
  );
};

export default Layout;
